import React, { useState } from 'react';
import Button from '@strava/ui/Button';
import PropTypes from 'prop-types';

import Modal from '@strava/ui/Modal';
import NavigationInformationNormalXsmall from '@strava/icons/NavigationInformationNormalXsmall';

import styles from './styles.scss';

const InfoModal = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const ContentModal = (
    <Modal isOpen={isModalOpen} onDismiss={toggleModalOpen} hasClose={true}>
      {children}
    </Modal>
  );

  return (
    <>
      <Button
        className={styles.infoButton}
        variant="icon"
        type="button"
        onClick={toggleModalOpen}
      >
        <NavigationInformationNormalXsmall color="grey" />
      </Button>
      {ContentModal}
    </>
  );
};

InfoModal.propTypes = {
  children: PropTypes.element.isRequired
};

export default InfoModal;
